<template>
	<v-button
		@clickHandler="$emit('clickHandler')"
		class="close-btn"
	>
		<i class="icon-close-btn"></i>
	</v-button>
</template>

<script>
import VButton from '@/components/atoms/VButton.vue'

export default {
	name: 'VButtonClose',
	components: {
		'v-button': VButton
	}
}
</script>

<style scoped lang="scss">
.close-btn.btn {
	min-width: 0;
	font-size: 25px;
	padding: 0;
	border: none;
	width: 25px;
  min-height: 20px;

	::v-deep {
		i {
			display: block;
			margin: 0 !important;
		}
	}
}

</style>
